import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ITokenDetails } from 'api/document_editing';
import { checkAnalysis, checkTranscription, getAnalysisOfDocument } from 'store/reducers/aiFunctionsCreator';

type TranscriptionData = {
  status: string;
  document_id?: string;
  updated_at?: string;
  summary?: string;
  language?: string;
} | null;

type initialStateType = {
  isTranscriptionChecking: boolean;
  isCheckingErorr: string;
  transcription: TranscriptionData;
  transcriptionText: string;
  sessionStatus: string | null;


  analysisError: string;
  checkingAnalysis: boolean;
  analysisData: any;
  analysisProcessStatus: string;

  isOpenAnalysisSider: boolean;
  analysisSiderWidth: number;
  isOpenAIAssistanceSider: boolean;
  assistanceSiderWidth: number;

  isSendToAnalysisOpen: boolean;

  currentEditorToken: string | null;
  editorTokenDetails: ITokenDetails | null;
};

const initialState: initialStateType = {
  isCheckingErorr: '',
  isTranscriptionChecking: false,
  transcription: null,
  transcriptionText: '',
  sessionStatus: null,


  analysisError: '',
  checkingAnalysis: false,
  analysisData: null,
  analysisProcessStatus: 'checking',

  isOpenAnalysisSider: false,
  analysisSiderWidth: 0,
  isOpenAIAssistanceSider: false,
  assistanceSiderWidth: 0,

  isSendToAnalysisOpen: false,

  currentEditorToken: null,
  editorTokenDetails: null,
};

const aiFunctionsSlice = createSlice({
  name: 'transcription',
  initialState,
  reducers: {
    setTranscription: (state, action: PayloadAction<TranscriptionData>) => {
      state.transcription = action.payload;
    },
    setTranscriptionText: (state, action: PayloadAction<string>) => {
      state.transcriptionText = action.payload;
    },
    setSessionStatus: (state, action: PayloadAction<string | null>) => {
      state.sessionStatus = action.payload;
    },

    setIsOpenAnalysisSider: (state, action: PayloadAction<{open: boolean, width: number}>) => {
      state.isOpenAnalysisSider = action.payload.open;
      state.analysisSiderWidth = action.payload.width;
    },
    setAnalysisData: (state, action: PayloadAction<any>) => {
      state.analysisData = action.payload;
    },
    setAnalysisProcessStatus: (state, action: PayloadAction<string>) => {
      state.analysisProcessStatus = action.payload;
    },

    setIsOpenAIAssistanceSider: (state, action: PayloadAction<{open: boolean, width: number}>) => {
      state.isOpenAIAssistanceSider = action.payload.open;
      state.assistanceSiderWidth = action.payload.width;
    },

    setIsSendToAnalysisOpen: (state, action: PayloadAction<any>) => {
      state.isSendToAnalysisOpen = action.payload;
    },

    setCurrentEditorToken: (state, action: PayloadAction<string | null>) => {
      state.currentEditorToken = action.payload;
    },
    setEditorTokenDetails: (state, action: PayloadAction<ITokenDetails | null>) => {
      state.editorTokenDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(checkTranscription.pending, (state) => {
      state.isTranscriptionChecking = true;
      state.isCheckingErorr = '';
    });

    builder.addCase(checkTranscription.rejected, (state, action: any) => {
      state.isCheckingErorr = action.payload;
      state.isTranscriptionChecking = false;
    });

    builder.addCase(checkTranscription.fulfilled, (state, action: PayloadAction<{status: string}>) => {
      state.isCheckingErorr = '';
      state.isTranscriptionChecking = false;
      state.transcription = action.payload;
    });

    builder.addCase(checkAnalysis.pending, (state) => {
      state.checkingAnalysis = true;
      state.analysisError = '';
    });

    builder.addCase(checkAnalysis.rejected, (state, action: any) => {
      state.analysisError = action.payload;
      state.checkingAnalysis = false;
    });

    builder.addCase(checkAnalysis.fulfilled, (state, action: PayloadAction<{status: string}>) => {
      state.analysisError = '';
      state.checkingAnalysis = false;
      state.analysisData = action.payload;
    });


    builder.addCase(getAnalysisOfDocument.pending, (state) => {
      state.checkingAnalysis = true;
      state.analysisError = '';
    });

    builder.addCase(getAnalysisOfDocument.rejected, (state, action: any) => {
      state.analysisError = action.payload;
      state.checkingAnalysis = false;
    });

    builder.addCase(getAnalysisOfDocument.fulfilled, (state, action: PayloadAction<{status: string}>) => {
      state.analysisError = '';
      state.checkingAnalysis = false;
      state.analysisData = action.payload;
    });


  },
});

const aiFunctionsReducer = aiFunctionsSlice.reducer;

export const { 
  setTranscription,
  setTranscriptionText,
  setSessionStatus,
  
  setIsOpenAnalysisSider,
  setAnalysisData,
  setAnalysisProcessStatus,

  setIsOpenAIAssistanceSider,

  setIsSendToAnalysisOpen,
  setCurrentEditorToken,
  setEditorTokenDetails,
 } = aiFunctionsSlice.actions;
 
export default aiFunctionsReducer;
